// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

import Layout from '../Layout.vue'
import LayoutExternal from '../LayoutExternal.vue'

import HomeView from '../views/HomeView.vue'
import Contacts from '../views/Contacts.vue'
import Blog from '../views/Blog.vue'
import Article from '../components/Blog/Article.vue'
import SuccessTrial from '../views/SuccessTrial.vue'
import Success from '../views/Success.vue'
import CalendlyView from '../views/Calendly/CalendlyView.vue'
import Privacy from '../views/Privacy.vue'
import Terms from '../views/Terms.vue'
import Trial from '@/views/Trial.vue'
import PRR from '@/views/PRR.vue'

const routes = [
  // Redireciona raiz -> /pt
  { path: '/', redirect: '/pt' },

  // Área principal com layout base e prefixo de idioma
  {
    path: '/:lang(en|pt|it)',
    component: Layout,
    children: [
      { path: '', name: 'home', component: HomeView },

      { path: 'contacts', name: 'contacts', component: Contacts },
      { path: 'contacts/evento_1', name: 'contacts-qr', component: Contacts },
      { path: 'contacts/success', name: 'success', component: Success },

      { path: 'blog', name: 'blog', component: Blog },
      { path: 'article/:id', name: 'article', component: Article, props: true },

      { path: 'success/trial', name: 'successTrial', component: SuccessTrial },

      { path: 'privacy', name: 'privacy', component: Privacy },
      { path: 'prr', name: 'prr', component: PRR },
      { path: 'trial', name: 'trial', component: Trial },
    ],
  },

  // Terms com layout externo
  {
    path: '/:lang(en|pt|it)/terms-and-conditions',
    component: LayoutExternal,
    children: [
      { path: '', name: 'terms', component: Terms },
    ],
  },

  // Rotas de schedule-call (com e sem lang)
  { path: '/schedule-call', name: 'calendly', component: CalendlyView },
  { path: '/:language/schedule-call', name: 'calendly-lang', component: CalendlyView },

  // Redirect do artigo sem lang para PT por omissão
  {
    path: '/article/:id',
    redirect: to => ({ path: `/pt/article/${to.params.id}` }),
  },

  // Fallback
  { path: '/:pathMatch(.*)*', redirect: '/pt' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

export default router
